import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { schools } from '../variables/schoolList';
import queryString from 'query-string';
import Pagination from './Pagination';
import { CSVLink, CSVDownload } from 'react-csv';

export default class Users extends Component {
  constructor(props) {
    super(props);

    let qs = queryString.parse(window.location.search);

    this.state = {
      user: JSON.parse(localStorage.getItem('tpuser')),
      isEditing: false,
      users: [],
      csv: [],
      total: 0,
      per_page: 500,
      page: qs.pag && qs.pag > 0 ? qs.pag : 1,
    };

    // Fast redirection?
    if (!this.state.user || this.state.user.role != 'admin')
      window.location.replace('/login');

    this.removeUser = this.removeUser.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.downloadCSV = this.downloadCSV.bind(this);
  }
  componentDidMount() {
    this.allUsers();
  }

  pageChange(p) {
    this.setState({ page: p }, this.allUsers);
  }

  allUsers() {
    fetch(
      process.env.REACT_APP_API_URL +
        '/users/all?p=' +
        this.state.page +
        '&pp=' +
        this.state.per_page,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.state.user.token,
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ users: data.items, total: data.total });
      })
      .catch((err) => console.log(err));
  }

  removeUser(e) {
    e.preventDefault();
    var qId = e.target.dataset.qid;
    fetch(process.env.REACT_APP_API_URL + '/users/' + qId + '/delete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.state.user.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        this.allUsers();
      });
  }

  downloadCSV() {
    fetch(process.env.REACT_APP_API_URL + '/users/all?p=1&&pp=10000', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.state.user.token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const parsed = data.items.map((u) => {
          u.results =
            u.results && u.results[0] && u.results[0].data.result
              ? u.results[0].data.result.join('')
              : '';
          delete u.password;
          delete u._id;
          return u;
        });
        this.setState({ csv: parsed });
      })
      .catch((err) => console.log(err));
  }

  render() {
    let users = this.state.users.map((b, bi) => {
      let result =
        b.results.length > 0 ? b.results[b.results.length - 1].data.result : [];
      result = result.join('');

      return (
        <tr key={bi}>
          <td>{b.name}</td>
          <td>{b.lastname}</td>
          <td>{b.lastname_mat}</td>
          <td>{b.email}</td>
          <td>
            {b.rut}-{b.dv}
          </td>
          <td>{b.mobile}</td>
          <td>{b.sex}</td>
          <td>{b.school}</td>
          <td>{b.school_comuna}</td>
          <td>{b.school_region}</td>
          <td>{b.grade}</td>
          <td>{b.ciudad}</td>
          <td>{b.carrera1}</td>
          {/* <td>{b.carrera2}</td>
          <td>{b.carrera3}</td> */}
          <td>{b.results.length}</td>
          <td>{result}</td>
          {/* <td></td> */}
          <td>
            <Link className='btn btn-border' to={'/admin/users/' + b._id}>
              Editar
            </Link>
          </td>
          <td>
            <button
              className='btn btn-danger'
              data-qid={b._id}
              onClick={this.removeUser}>
              Eliminar
            </button>
          </td>
        </tr>
      );
    });
    let calculoPag =
      this.state.total <= this.state.per_page
        ? 1
        : parseInt(this.state.total / this.state.per_page) + 1;

    return (
      <div id='user' className='container'>
        <h1 className='upper title margin-bot-20'>
          Usuarios
          {this.state.csv.length === 0 && (
            <button
              className='btn btn-border float-right'
              onClick={this.downloadCSV}>
              Generar CSV
            </button>
          )}
          {this.state.csv.length > 0 && (
            <span className='btn btn-border float-right'>
              <CSVLink data={this.state.csv}>Descargar CSV</CSVLink>
            </span>
          )}
          <Link
            className='btn btn-border float-right'
            to='/admin/users/massive'>
            Carga Masiva
          </Link>
        </h1>
        <table className='table table-sm bg-white'>
          <thead>
            <tr>
              <th scope='col'>Nombre</th>
              <th scope='col'>Apellido P</th>
              <th scope='col'>Apellido M</th>
              <th scope='col'>Email</th>
              <th scope='col'>RUT</th>
              <th scope='col'>Teléfono</th>
              <th scope='col'>Género</th>
              <th scope='col'>RBD Colegio</th>
              <th scope='col'>RBD Comuna</th>
              <th scope='col'>RBD Región</th>
              <th scope='col'>Curso</th>
              <th scope='col'>Estudiar en</th>
              <th scope='col'>Preferencia 1</th>
              {/* <th scope='col'>Preferencia 2</th>
              <th scope='col'>Preferencia 3</th> */}
              <th scope='col'>Test</th>
              <th scope='col'>Resultado</th>
              {/* <th scope="col">Personalidad</th> */}
              <th scope='col'></th>
              <th scope='col'></th>
            </tr>
          </thead>
          <tbody>{users}</tbody>
        </table>

        <Pagination
          currentPage={this.state.page}
          totalPages={calculoPag}
          pageChange={this.pageChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/AllUsers.jsx